import { render } from "./ButtonNumber.vue?vue&type=template&id=12b51616&scoped=true"
import script from "./ButtonNumber.vue?vue&type=script&lang=js"
export * from "./ButtonNumber.vue?vue&type=script&lang=js"

import "./ButtonNumber.vue?vue&type=style&index=0&id=12b51616&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b51616"]])

export default __exports__